import { COMPLETE_GET_CLIENT } from 'common/actions/clientActions';
import { START_GET_SCHEDULE,
        COMPLETE_GET_SCHEDULE,
        COMPLETE_GET_CATEGORIES,
        SET_STATUS_FILTER,
        SET_NETWORK_FILTER,
        SET_SPORTS_FILTER,
        SET_DATE_FILTER,
        SET_REPLAY_DATE_FILTER } from '../actions';

const today = new Date();

module.exports = function scheduleReducer(state = {
    statusFilterValue: 'live',
    dateFilterEndValue: today,
    dateFilterStartValue: today,
    sportsFilterValue: '',
    sportsFilterType: 'category',
    networkFilter: ''
}, action) {
    switch (action.type) {
        case COMPLETE_GET_CLIENT:
            return { ...state, channels: action.client.channels };

        case COMPLETE_GET_CATEGORIES:
            return { ...state, categories: action.categories };

        case START_GET_SCHEDULE:
            return { ...state, loading: true };

        case COMPLETE_GET_SCHEDULE:
            return { ...state, listings: action.listings, loading: false };

        case SET_STATUS_FILTER:
            return { ...state, statusFilterValue: action.status };

        case SET_NETWORK_FILTER:
            return { ...state, networkFilter: action.value, networkFilterLabel: action.label };

        case SET_SPORTS_FILTER:
            return {
                ...state,
                sportsFilterValue: action.value,
                sportsFilterType: action.filterType,
                sportsFilterLabel: action.label
            };

        case SET_DATE_FILTER:
            return { ...state, dateFilterStartValue: action.date, dateFilterEndValue: action.date };

        case SET_REPLAY_DATE_FILTER:
            return { ...state, dateFilterStartValue: action.startDate, dateFilterEndValue: action.endDate };

        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./app/schedule/reducers/index.js